import PropTypes from 'prop-types';
import DropdownMenu from 'modules/shared/common/components/DropdownMenu';

const TimeSlotsDropdown = ({
  timeSlotsArr,
  selectedTimeSlot,
  handleTimeSlotDropdownMenuChange,
  objectMapper,
}) => {
  return (
  <DropdownMenu
    dropdownMenuItemsList={timeSlotsArr}
    dropdownMenuSelectedObj={selectedTimeSlot}
    handleDropdownMenuChange={handleTimeSlotDropdownMenuChange}
    objectMapper={objectMapper}
  />
)};

TimeSlotsDropdown.propTypes = {
  timeSlotsArr: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selectedTimeSlot: PropTypes.shape({}).isRequired,
  handleTimeSlotDropdownMenuChange: PropTypes.func.isRequired,
};

TimeSlotsDropdown.defaultProps = {};

export default TimeSlotsDropdown;
